/**
 * Reiter „Zähler“ eines Gebäudes: Zählerhierarchie (Baum, Drag-and-Drop, Zählerdaten), Zählerdaten
 * (Laufzeitdaten-Dashboard) und Lieferverträge. Der Unterreiter steht in der Adresse (`&meterView=data`).
 */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import MeterHierarchyPanel from "./MeterHierarchyPanel";
import MeterDataDashboard from "./MeterDataDashboard";
import SupplyContractsPanel from "./SupplyContractsPanel";

const PARAM = "meterView";
const VIEWS = ["hierarchy", "data", "contracts"];

export default function MetersTab({ building }: { building: any }) {
  const { t } = useTranslation();
  const [view, setView] = useState(() => {
    const v = new URLSearchParams(window.location.search).get(PARAM);
    return v && VIEWS.includes(v) ? v : "hierarchy";
  });
  const select = (next: string) => {
    setView(next);
    const params = new URLSearchParams(window.location.search);
    if (next !== "hierarchy") params.set(PARAM, next);
    else params.delete(PARAM);
    window.history.replaceState(null, "", `${window.location.pathname}?${params.toString()}`);
  };
  return (
    <Tabs value={view} onValueChange={select} className="min-w-0">
      <TabsList>
        <TabsTrigger value="hierarchy">{t("meterData.tabHierarchy")}</TabsTrigger>
        <TabsTrigger value="data">{t("meterData.tabData")}</TabsTrigger>
        <TabsTrigger value="contracts">{t("meterData.tabContracts")}</TabsTrigger>
      </TabsList>
      <TabsContent value="hierarchy" className="mt-3">
        <MeterHierarchyPanel building={building} />
      </TabsContent>
      <TabsContent value="data" className="mt-3">
        {view === "data" ? <MeterDataDashboard building={building} /> : null}
      </TabsContent>
      <TabsContent value="contracts" className="mt-3">
        {view === "contracts" ? <SupplyContractsPanel building={building} /> : null}
      </TabsContent>
    </Tabs>
  );
}
